import createCache, { EmotionCache } from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "@mui/stylis-plugin-rtl";

export const createRtlCache = (): EmotionCache =>
  createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

export const createLtrCache = (): EmotionCache =>
  createCache({
    key: "mui",
  });
